import React from 'react';
import ReactDOM from 'react-dom';
import { apiFetchData } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/apiService';
import { reportError } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/reportService';

export default class BlogSidebar extends React.Component {
    constructor(props) {
        super(props);
        this.pathExtension = 'blog/suggestion/';
        this.state = {
            publicResources: null,
        };
        this.getData = this.getData.bind(this);
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        const stateData = this.state;
        const guideId = document.getElementById('blogSidebarReact').getAttribute('data-guide');
        if (!stateData.publicResources) {
            apiFetchData(this.pathExtension, `/10/0/${guideId}`)
                .then((res) => {
                    if (res.status === 200) {
                        this.setState({
                            publicResources: res.data,
                        });
                        return;
                    }
                    reportError(res);
                })
                .catch((err) => {
                    // this.setState({
                    //     errorMsg: err,
                    // });
                    reportError(err);
                })
                .finally(() => {
                    // this.setState({
                    //     isLoading: false,
                    // });
                });
        }
    }

    render() {
        const fetchData = this.state;
        return (
            <>
                {fetchData.publicResources && (
                    <div>
                        <div className="sideMenu blog-sidebar" id="blog">
                            <h3>{fetchData.publicResources.mainTitle}</h3>
                            <ul className="blog-sidebar__list">
                                {fetchData.publicResources.blogItems.map((item, index) => (
                                    <li key={index} className="blog-sidebar__list-item">
                                        <a href={item.readMoreURL}>
                                            <img src={item.image.sourceURL} alt={item.image.altText} title={item.image.titleText} />
                                            <div className="blog-sidebar-information">
                                                <p className="blog-sidebar__date">{item.publishDate}</p>
                                                <p className="blog-sidebar__title">{item.title}</p>
                                            </div>
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                )}
            </>
        );
    }
}

const aboutUs = document.getElementById('blogSidebarReact');
ReactDOM.render(<BlogSidebar />, aboutUs);
